// src/app/app-routing.module.ts

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'readQR',
    pathMatch: 'full',
  },
  {
    path: 'readQR',
    loadChildren: () =>
      import('./pages/read-qr/read-qr.module').then(m => m.ReadQrModule),
  },
  {
    path: '**',
    redirectTo: 'readQR',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
